export const storeKeys = {
    "userdata" : 'ufarmx-user',
    "useremail" : 'user-email'
}

export const getItemFromStorage = (key, isJson = true) => {

    const value = localStorage.getItem(key);

    if (value == null) return null;

    if (isJson) return JSON.parse(value)

    return value;
}

export const setItemInStorage = (key, value, isJson = true) => {

}

export const removeItemFromStorage = (key) => {
    localStorage.removeItem(key);
    
}